/** Список ролей сервера с поиском и чекбоксами. */
import type { RoleInfo } from '../api.js';
import { h, hexColor } from '../dom.js';

export function rolePicker(roles: RoleInfo[], selected: Set<string>, opts: { onChange?: () => void; compact?: boolean } = {}) {
  const search = h('input', { class: 'input', placeholder: 'Поиск роли...', attrs: { 'aria-label': 'Поиск роли' } });
  const list = h('div', { class: ['role-list', opts.compact && 'is-compact'] });
  const render = () => {
    const q = search.value.trim().toLowerCase();
    list.replaceChildren(
      ...roles
        .filter((r) => !r.everyone && !r.managed && (!q || r.name.toLowerCase().includes(q)))
        .map((r) => {
          const cb = h('input', { type: 'checkbox', checked: selected.has(r.id) });
          cb.addEventListener('change', () => {
            cb.checked ? selected.add(r.id) : selected.delete(r.id);
            opts.onChange?.();
          });
          return h('label', { class: 'role-item' }, cb, h('span', { class: 'role-dot', style: { background: r.color ? hexColor(r.color) : '#99aab5' } }), h('span', { class: 'role-name' }, r.name));
        }),
    );
  };
  search.addEventListener('input', render);
  render();
  return h('div', { class: 'role-picker' }, search, list);
}

export function roleNames(roles: RoleInfo[], ids: string[]): string {
  const names = ids.map((id) => roles.find((r) => r.id === id)?.name).filter(Boolean) as string[];
  return names.length ? names.join(', ') : '-';
}
